import { render, staticRenderFns } from "./ItemStockModal.vue?vue&type=template&id=3b0161dc&scoped=true"
import script from "./ItemStockModal.vue?vue&type=script&lang=js"
export * from "./ItemStockModal.vue?vue&type=script&lang=js"
import style0 from "./ItemStockModal.vue?vue&type=style&index=0&id=3b0161dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0161dc",
  null
  
)

export default component.exports